<!-- 选题申请 -->
<template>
  <svg
    t="1748246633595"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="16447"
    width="200"
    height="200"
  >
    <path
      d="M478.4128 876.3392H240.64a29.930057 29.930057 0 0 1-29.9008-29.9008V153.658514c0-16.501029 13.399771-29.871543 29.9008-29.871543h517.178514c16.501029 0 29.9008 13.370514 29.9008 29.871543v449.009372a212.260571 212.260571 0 0 0-119.456914-36.629943 213.313829 213.313829 0 0 0-189.8496 310.301257z"
      fill="#40BF7C"
      p-id="16448"
    />
    <path
      d="M544.475429 391.519086c0-20.801829-16.852114-37.624686-37.624686-37.624686H292.278857a18.812343 18.812343 0 0 0 0 37.624686h214.571886c20.772571 0 37.624686-16.852114 37.624686-37.624686v37.624686zM660.2752 524.434286c0-20.772571-16.852114-37.624686-37.624686-37.624686H292.278857a18.812343 18.812343 0 0 0 0 37.624686h350.8224a17.173943 17.173943 0 0 0 17.173943-17.173943v17.173943z"
      fill="#FFFFFF"
      p-id="16449"
    />
    <path
      d="M860.16 58.543543a40.199314 40.199314 0 0 0-56.846629 0L591.286857 270.570057a40.111543 40.111543 0 0 0 0.029257 56.875886 40.170057 40.170057 0 0 0 56.846629 0l212.026514-212.026514a40.199314 40.199314 0 0 0 0-56.846629l-0.029257-0.029257z"
      fill="#40BF7C"
      p-id="16450"
    />
    <path
      d="M860.16 58.543543a40.199314 40.199314 0 0 0-56.846629 0L591.286857 270.570057a40.111543 40.111543 0 0 0 0.029257 56.875886 40.170057 40.170057 0 0 0 56.846629 0l212.026514-212.026514a40.199314 40.199314 0 0 0 0-56.846629l-0.029257-0.029257z m-24.839314 24.810057l0.058514 0.029257a5.090743 5.090743 0 0 1 0 7.197257l-212.055771 212.055772a5.090743 5.090743 0 0 1-7.197258 0l-0.029257-0.058515a5.149257 5.149257 0 0 1-1.492114-3.598628c0-1.345829 0.555886-2.633143 1.492114-3.598629l212.026515-212.026514a5.061486 5.061486 0 0 1 7.197257 0z"
      fill="#FFFFFF"
      p-id="16451"
    />
    <path
      d="M708.461714 961.9456a189.293714 189.293714 0 0 1-229.931885-184.817371 189.293714 189.293714 0 0 1 189.205942-189.205943 189.293714 189.293714 0 0 1 182.418286 239.528228 97.543314 97.543314 0 0 0-22.410971-14.365257 164.074057 164.074057 0 0 0-160.007315-199.943314 164.074057 164.074057 0 0 0-163.986285 163.986286 164.074057 164.074057 0 0 0 191.517257 161.674971c3.335314 8.338286 7.811657 16.091429 13.194971 23.1424z"
      fill="#FFA864"
      p-id="16452"
    />
    <path
      d="M773.588114 687.074743l-156.906057 156.906057-71.182628-71.358171-27.355429 27.355428 98.538057 98.7136 184.261486-184.261486-27.355429-27.355428z"
      fill="#40BF7C"
      p-id="16453"
    />
  </svg>
</template>
